<ng-container *ngIf="isVisible">
    <div
        [id]="field.id"
        class="{{ DividerClass.Base }}"
        [ngClass]="[
            field.panelClass,
            orientationClass,
            dividerColorClass$ | async,
            getDividerThicknessClass(),
            getDividerStyleClass()
        ]"
        [ngStyle]="getStyleObject()"
    ></div>
</ng-container>
